/**
 * @file 标记他人号码-mark_major
 * @author
 */

import React from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';

import StepsMenu from '../../components/StepsMenu/index';
import Step1 from './step1';
import Step2 from './step2';
import Step3 from './step3';

import {Carousel} from 'antd';

import {
    fetchCaptcha,
    fetchReportSubmit,
    updateMark,
    cleanMark,
    fetchMarkTag
} from '../../actions/markAction';
import {
    fetchSmsCode,
} from '../../actions/attestAction';

import {getQueryString} from '../../util';

import imgPhoneEdit from './imgs/phone-edit.png';
import imgPhoneEditNormal from './imgs/phone-edit-normal.png';
import imgMsgEdit from './imgs/msg-edit.png';
import imgMsgEditNormal from './imgs/msg-edit-normal.png';
import imgSubmitSuccess from './imgs/submit-success.png';
import imgSubmitSuccessNormal from './imgs/submit-success-normal.png';

import './mark.less';

export class Mark extends React.Component<any, any> {
    constructor(prop) {
        super(prop);
    }

    componentDidMount() {
        this.getTagList();
        const searchUrl = getQueryString('phones');
        let phoneListTemp = [] as any;
        if (searchUrl) {
            try {
                // /mark?phones=%5B%7B"phone"%3A"037123716023"%7D%5D
                phoneListTemp = JSON.parse(decodeURIComponent(getQueryString('phones')));
                this.props.updateMark({
                    phone: phoneListTemp[0].phone,
                    curStep: 2
                });

            } catch (e) {
                console.log(e);
            }
        }
        window.scrollTo(0, 0);
    }

    componentWillUnmount() {
        this.props.cleanMark();
    }
    getTagList () {
        this.props.fetchMarkTag();
    }
    render() {
        const stepList = [
            {
                title: '1.填写号码信息',
                imgNormal: imgPhoneEditNormal,
                img: imgPhoneEdit
            },
            {
                title: '2.填写标记信息',
                imgNormal: imgMsgEditNormal,
                img: imgMsgEdit
            },
            {
                title: '3.提交等待审核',
                imgNormal: imgSubmitSuccessNormal,
                img: imgSubmitSuccess
            }
        ];
        const {markData} = this.props;
        return (
            <div className={'mark-page'}>
                <div className="banner">
                    <Carousel className="custom-carousel-class" autoplay={false}>
                        <div className="carousel-item">
                            <div className="item-info-wrapper">
                                <p className="title">
                                    12321号码投诉
                                </p>
                                <div className="title-tip">
                                    <div>百度&12321合作共建不良号码举报，投诉会同步12321处理</div>
                                </div>
                            </div>
                        </div>
                    </Carousel>
                </div>

                <div className="steps-menu">
                    <StepsMenu data={stepList} curStep={markData.curStep} />
                </div>
                <div className="mark-page-content">
                    {markData.curStep === 1
                        && <Step1 {...this.props} inputPlaceholder="请输入需要标记的号码" />}
                    {markData.curStep === 2 && <Step2 {...this.props} />}
                    {markData.curStep === 3
                        && <Step3
                            {...this.props}
                            tip="感谢您的反馈，您的反馈信息会进入标记库，我们会通过大数据显示多数人的标记信息"
                            btn1Url="/home"
                            btn1Text="返回首页"
                            // btn2Text="查看记录"
                            btn2Url="/user_center/my_mark"
                        />
                    }
                </div>
            </div>
        );
    }

}
function mapStateToProps(state) {
    return {
        markData: state.markReducer
    };
}

function mapDispatchToProps(dispatch) {
    return {
        fetchCaptcha: obj => fetchCaptcha(dispatch, obj),
        fetchReportSubmit: obj => fetchReportSubmit(dispatch, obj),
        updateMark: obj => updateMark(dispatch, obj),
        cleanMark: () => cleanMark(dispatch),
        fetchMarkTag: () => fetchMarkTag(dispatch),
        fetchAttestSendCode: obj => fetchSmsCode(dispatch, obj),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Mark as any));
